import React from 'react';
import { motion } from 'framer-motion';

/**
 * ImageZoom - Un composant réutilisable pour ajouter un effet de zoom au survol.
 * 
 * @param {string} src - L'URL de l'image.
 * @param {string} alt - Le texte alternatif de l'image.
 * @param {string} className - Classes CSS supplémentaires pour le conteneur.
 */
const ImageZoom = ({ src, alt, className = "" }) => {
    return (
        <div className={`w-full h-full overflow-hidden cursor-zoom-in relative ${className}`}>
            <motion.img
                src={src}
                alt={alt}
                className="w-full h-full object-cover transition-transform duration-200 ease-out"
                initial={{ opacity: 0, scale: 1.04 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.35 }}
                onMouseMove={(e) => {
                    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
                    // On calcule la position relative de la souris en prenant en compte le scroll
                    const x = ((e.pageX - left - window.scrollX) / width) * 100;
                    const y = ((e.pageY - top - window.scrollY) / height) * 100;

                    e.currentTarget.style.transformOrigin = `${x}% ${y}%`;
                    e.currentTarget.style.transform = 'scale(2.5)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.transformOrigin = 'center';
                }}
            />
        </div>
    );
};

export default ImageZoom;
